import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, FullTable } from 'components';
import { PermissionList, RolePermission, useModal } from 'utils';
import { goalActions } from 'store';
import { GOAL_SECTION_ACTION_TYPE, goalSectionHead, goalSectionBody, goalSectionNotYet } from './constants';
import { AddGoalSection } from './addGoalSection';

export const GoalSections = ({}) => {
    const sectionTypes = useSelector((state) => state.goals.sectionTypes);
    const dispatch = useDispatch();
    const { open } = useModal();

    useEffect(() => {
        dispatch(goalActions.getSectionTypes());
    }, [dispatch]);

    const handleClickButton = (item, name) => {
        if (name === 'editSection') {
            open(<AddGoalSection info={item} />);
        }
    };

    return (
        <div>
            {RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code]) && (
                <div className="header-action-btn">
                    <AddCircleBlue text={'Add Goal Section'} handleClick={() => open(<AddGoalSection />)} />
                </div>
            )}
            <FullTable
                head={goalSectionHead}
                body={goalSectionBody}
                loadingType={GOAL_SECTION_ACTION_TYPE}
                list={sectionTypes || []}
                handleClickButton={handleClickButton}
                notYet={goalSectionNotYet}
                margin={'0'}
            />
        </div>
    );
};
